import React from 'react'
import { setWithExpiry, getWithExpiry } from '@util/LocalStorage'

const useProductionSSOValidator = (): void => {
    React.useEffect(() => {
        if (process.env.NODE_ENV !== 'development') {
            const hash = window.location.hash
            const tokenData = hash.split('#accessToken=')
            const token = tokenData?.[1]
            const tokenFromStore = getWithExpiry('token')
            if (token || tokenFromStore) {
                if (token) {
                    setWithExpiry('token', token, 30 * 60 * 1000)
                }
                window.location.href = `${origin}${window.location.pathname}#/dashboard`
            } else {
                window.location.href = `${origin}${window.location.pathname}#/login`
            }
        }
    }, [])
}

export default useProductionSSOValidator
